import React from 'react';

import { BlockPicker, BlockPickerProps } from 'react-color';

import { COLORS } from './constants';

type Props = BlockPickerProps;

const ColorPicker = ({ ...restProps }: Props) => {
  return <BlockPicker colors={COLORS} {...restProps} />;
};

export default ColorPicker;
